import PublicLayout from "@/components/PublicLayout";

const CONTENT = {
  how: {
    title: "كيف تعمل MERQAV",
    intro: "منصة MERQAV تعمل كوسيط تقني وتجاري بين المصانع والعملاء الذين يحتاجون قطعاً أو خدمات صناعية وبين ورش التصنيع والمصنعين ومزودي الخدمات المؤهلين. لا نُتيح تواصلاً مباشراً بين الطرفين.",
    sections: [
      { h: "1. إرسال الطلب", p: "ارفع صور القطعة أو الرسومات الفنية أو مواصفاتها. لا تحتاج لأن تكون مهندساً — نحن ندرس ونحلل." },
      { h: "2. الفحص الفني", p: "عند الحاجة يقوم فريقنا بزيارة موقعك، معاينة القطعة، وإعداد الرسومات والمواصفات المطلوبة." },
      { h: "3. اختيار الورشة", p: "نُرسل الطلب بشكل مجهول الهوية إلى الورش المؤهلة المناسبة. لا يتم كشف اسم منشأتك." },
      { h: "4. مقارنة العروض", p: "نُقارن العروض السرية للورش تقنياً ومالياً ونختار الأنسب لك." },
      { h: "5. عرض السعر الرسمي", p: "تستلم عرضاً رسمياً واحداً من MERQAV يشمل الفحص والخدمات وضريبة القيمة المضافة." },
      { h: "6. التصنيع والفحص", p: "بعد اعتماد العرض نتابع الإنتاج مرحلة بمرحلة، ثم نقوم بفحص الجودة قبل التسليم." },
      { h: "7. التسليم والأرشفة", p: "يتم تسليم القطعة إليك، وتُحفظ مواصفاتها في مكتبتك الرقمية لإعادة الطلب لاحقاً." },
    ],
  },
  about: {
    title: "من نحن",
    intro: "MERQAV منصة تنسيق المشاريع الصناعية والتوريد التي تربط العملاء بالورش والمصانع والمصنعين والمفتشين ومزودي الخدمات الصناعية المؤهلين في المملكة العربية السعودية. مهمتنا هي تسهيل الوصول إلى القدرات الصناعية بجودة عالية وسرية تامة.",
    sections: [
      { h: "رسالتنا", p: "نربط الصناعة... ونبني الثقة. عبر منصة موثوقة تحفظ السرية وتضمن الجودة والالتزام بمواعيد التسليم." },
      { h: "لماذا MERQAV؟", p: "لأننا نتحمل المسؤولية الكاملة من استلام الطلب حتى التسليم. نُدير كافة تفاصيل التنسيق التقني والتجاري والفحص واللوجستيات." },
      { h: "قيمنا", p: "الاحترافية، السرية، الجودة، والالتزام. نتعامل مع كل مشروع كما لو كان مشروعنا الخاص." },
    ],
  },
  faq: {
    title: "الأسئلة الشائعة",
    intro: "إجابات على أهم الأسئلة حول منصة MERQAV وطريقة عملها.",
    sections: [
      { h: "هل تكشف MERQAV اسم منشأتي للورشة المصنعة؟", p: "لا. جميع الطلبات المرسلة للورش تكون مجهولة الهوية، ونحن نتحمل مسؤولية التنسيق الكامل." },
      { h: "هل يمكنني التواصل مع الورشة مباشرة؟", p: "لا. جميع الاتصالات والمراسلات تتم من خلال MERQAV فقط لضمان السرية والحيادية." },
      { h: "ما هي أنواع الملفات المدعومة؟", p: "الصور، الفيديوهات، PDF، Word، Excel، وملفات CAD مثل DWG، DXF، STEP، STP، IGES، STL، وZIP." },
      { h: "كم يستغرق إعداد عرض السعر؟", p: "عادة من 2 إلى 5 أيام عمل، وقد يزيد إذا احتاج الأمر إلى فحص فني في الموقع." },
      { h: "هل تشمل الأسعار ضريبة القيمة المضافة؟", p: "نعم، جميع عروض MERQAV تشمل ضريبة القيمة المضافة بنسبة 15% بشكل واضح." },
      { h: "هل يمكن إعادة تصنيع قطعة سبق تصنيعها؟", p: "نعم، جميع القطع المكتملة تُحفظ في مكتبتك الرقمية ويمكن إعادة طلبها بضغطة زر." },
    ],
  },
  contact: {
    title: "تواصل معنا",
    intro: "فريق MERQAV جاهز لخدمتك. تواصل معنا عبر أي من القنوات التالية.",
    sections: [
      { h: "البريد الإلكتروني", p: "info@merqav.sa" },
      { h: "الهاتف", p: "+966 11 000 0000" },
      { h: "العنوان", p: "المملكة العربية السعودية، الرياض" },
      { h: "ساعات العمل", p: "الأحد - الخميس، 8:00 صباحاً - 5:00 مساءً" },
    ],
  },
  terms: {
    title: "الشروط والأحكام",
    intro: "باستخدامك منصة MERQAV فإنك توافق على الشروط والأحكام التالية.",
    sections: [
      { h: "1. تعريف الخدمة", p: "MERQAV منصة تنسيق مشاريع صناعية وتوريد تعمل كوسيط تقني وتجاري بين العملاء والورش والمصنعين والمفتشين ومزودي الخدمات." },
      { h: "2. سرية البيانات", p: "تلتزم MERQAV بحفظ سرية جميع الملفات والبيانات الفنية الخاصة بالعميل." },
      { h: "3. المدفوعات", p: "تُدفع الفواتير وفق الشروط الموضحة في عرض السعر المعتمد." },
      { h: "4. الضمان", p: "تُقدم MERQAV ضماناً على القطع المصنعة وفق ما هو محدد في كل طلب." },
    ],
  },
  privacy: {
    title: "سياسة الخصوصية",
    intro: "نحرص على حماية بياناتك الشخصية والفنية.",
    sections: [
      { h: "جمع البيانات", p: "نجمع فقط البيانات اللازمة لتقديم الخدمة." },
      { h: "استخدام البيانات", p: "تُستخدم البيانات لتنفيذ الطلبات والتواصل مع العملاء فقط." },
      { h: "حماية البيانات", p: "نستخدم أعلى معايير التشفير لحماية بياناتك." },
    ],
  },
  confidentiality: {
    title: "سياسة السرية",
    intro: "السرية هي حجر الأساس في منصة MERQAV.",
    sections: [
      { h: "بيانات العملاء والمصانع", p: "لا تُكشف هوية العميل أو المنشأة أو بياناته للورش أو المصنعين." },
      { h: "بيانات الورش والمصنعين", p: "لا تُكشف هوية الورش أو تسعيرها للعملاء بشكل مباشر." },
      { h: "الرسومات الفنية", p: "جميع الرسومات محمية وتستخدم فقط لأغراض التصنيع." },
    ],
  },
};

export function StaticPage({ pageKey }) {
  const data = CONTENT[pageKey];
  return (
    <PublicLayout>
      <section className="py-16 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-xs font-bold tracking-widest text-brand-amber mb-3">MERQAV</div>
          <h1 className="text-4xl font-bold text-brand-navy mb-4" data-testid={`page-title-${pageKey}`}>{data.title}</h1>
          <p className="text-slate-600 leading-relaxed text-lg">{data.intro}</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 space-y-8">
          {data.sections.map((s, i) => (
            <div key={`${pageKey}-${s.h}`} className="card-industrial p-6" data-testid={`page-section-${pageKey}-${i}`}>
              <h3 className="text-xl font-semibold text-brand-navy mb-2">{s.h}</h3>
              <p className="text-slate-600 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}

export const HowItWorks = () => <StaticPage pageKey="how" />;
export const AboutPage = () => <StaticPage pageKey="about" />;
export const FaqPage = () => <StaticPage pageKey="faq" />;
export const ContactPage = () => <StaticPage pageKey="contact" />;
export const TermsPage = () => <StaticPage pageKey="terms" />;
export const PrivacyPage = () => <StaticPage pageKey="privacy" />;
export const ConfidentialityPage = () => <StaticPage pageKey="confidentiality" />;
